import styles from "./SocialLinks.module.css";

import githubIcon from "../../assets/icons/github.svg";
import gmailIcon from "../../assets/icons/gmail.svg";
import linkedinIcon from "../../assets/icons/linkedin.svg";
import resumeIcon from "../../assets/icons/resume.svg";

const socialLinks = [
  {
    id: "github",
    name: "Github",
    link: "https://github.com/harshh3010",
    icon: githubIcon,
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/harsh-gyanchandani-9a64b01b2/",
    icon: linkedinIcon,
  },
  {
    id: "gmail",
    name: "GMail",
    link: "mailto:harsh.gyanchandani@gmail.com",
    icon: gmailIcon,
  },
  {
    id: "resume",
    name: "Resume",
    link: "https://drive.google.com/file/d/10XwRVSb-w2lhdt60kLtngAhyLZInc0oI/view?usp=sharing",
    icon: resumeIcon,
  },
];

const SocialLinks = (props) => {
  const links = socialLinks.map((link) => {
    return (
      <li key={link.id}>
        <a rel="noreferrer" href={link.link} target="_blank">
          <img src={link.icon} alt={link.name} className={styles["icon"]} />
        </a>
      </li>
    );
  });

  return <ul className={styles["social-links"]}>{links}</ul>;
};

export default SocialLinks;
